import React from 'react';

const Contact = () => {
  const contactMethods = [
    {
      image: "/images/emil.png",
      title: "Email",
      value: "Mohammad.ka507@gmail.com",
      link: "mailto:Mohammad.ka507@gmail.com"
    },
    {
      image: "/images/call.png",
      title: "Telefon",
      value: "+46 73 623 35 51",
      link: "tel:+46736233551"
    },
    {
      image: "/images/ln.png",
      title: "LinkedIn",
      value: "www.linkedin.com/in/mohammad",
      link: "https://www.linkedin.com/in/mohammad-kanaan-899967307", 
      target: "_blank"

    }
    
  ];

  const handleDownload = (filename) => {
    const link = document.createElement('a');
    link.href = `/assets/${filename}`;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Modern Google Maps med mörkt tema och anpassad styling
  const modernMapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d64992.87316701836!2d13.447312949999999!3d59.326636!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465cb2394a62166d%3A0x4019078290e7c40!2sKarlstad!5e0!3m2!1ssv!2sse!4v1700000000000!5m2!1ssv!2sse";

  return (
    <section id="contact" className="section section-light">
      <div className="container">
        <h2>Kontakta Mig</h2>
        <div className="contact-grid">
          <div className="contact-info">
            {contactMethods.map((method, index) => (
              <a 
  key={index}
  href={method.link}
  className="contact-item"
  onClick={(e) => method.link === '#' && e.preventDefault()}
  target={method.target || "_self"}
  rel={method.target ? "noopener noreferrer" : ""}
>
                <div className="contact-icon">
                   {method.image ? (
    <img src={method.image} alt={method.title} className="contact-image" />
  ) : (
    method.icon
  )}
                </div>
                <div className="contact-details">
                  <h4>{method.title}</h4>
                  <p>{method.value}</p>
                </div>
              </a>
            ))}
            
            {/* Modern Karlstad Karta */}
            <div className="modern-map-container">
              <div className="map-header">
                <div className="map-icon-wrapper">
                  <div className="pulse-dot"></div>
                  <div className="map-icon">
  <img src="/images/pin.png" alt="Location pin" className="map-pin-image" />
</div>
                </div>
                <div className="map-title">
                  <h4>Karlstad</h4>
                  <p>Värmland, Sverige</p>
                </div>
              </div>
              
              <div className="modern-map-wrapper">
                <iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d16282.139225209902!2d13.500108668316247!3d59.37920220000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465cb2396c3cbc0b%3A0xee6f12c15b2f3e4d!2sKarlstad%20Centralstation!5e0!3m2!1ssv!2sse!4v1700000000000!5m2!1ssv!2sse"
  width="100%"
  height="200"
  style={{border: 0, borderRadius: '12px'}}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
  title="Karlstad Centrum Karta"
></iframe>
                <div className="map-overlay"></div>
              </div>

              <div className="map-footer">

                <a 
                  href="https://maps.google.com/?q=Karlstad,Sverige" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="modern-map-link"
                >
                  <span>🌐</span>
                  Öppna i Maps
                </a>
              </div>
            </div>
          </div>
          
          <div className="contact-form-section">
            <div className="skill-category">
              <h3>Ladda Ner Dokument</h3>
              <div style={{display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '2rem'}}>
                <button 
                  onClick={() => handleDownload('Mohammad-cv.pdf')} 
                  className="btn btn-primary"
                  style={{textAlign: 'center'}}
                >
                  📄 Ladda ner CV
                </button>
                <button 
                  onClick={() => handleDownload('PRO-personligtbrev.pdf')} 
                  className="btn btn-secondary"
                  style={{textAlign: 'center'}}
                >
                  ✉️ Personligt Brev
                </button>
              </div>
              
              <div style={{marginTop: '2rem', padding: '1.5rem', background: 'var(--bg-secondary)', borderRadius: '12px'}}>
  <h4 style={{marginBottom: '1rem'}}>Referens</h4>
  <p><strong>Kathy Överby</strong></p>
  <p>Butikschef, Guldfynd</p>
  <p style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
    <img src="/images/call.png" alt="call" style={{width: '20px', height: '20px'}} />
    070-393 60 82
  </p>
</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;